import {UbcLogger} from '@baidu/ubc-report-sdk';
import dayjs from 'dayjs';

const tutorialScoreId = 18485; // 客户反馈打分收集
const createCharacterTimeId = 18486; // 范例页停留
const createCharacterOpenId = 18487; // 范例页打开


const tutorialScoreLogger = new UbcLogger({
    from: 'script',
    page: 'huibo',
    ev_l_t: 'click',
    serverId: tutorialScoreId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const createCharacterTimeLogger = new UbcLogger({
    from: 'script',
    page: 'huibo',
    ev_l_t: 'click',
    serverId: createCharacterTimeId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const createCharacterOpenLogger = new UbcLogger({
    from: 'script',
    page: 'huibo',
    ev_l_t: 'click',
    serverId: createCharacterOpenId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const logMap = {
    tutorialScore: {
        logger: tutorialScoreLogger,
        commonParams: {
            from: 'script',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    },
    createCharacterTime: {
        logger: createCharacterTimeLogger,
        commonParams: {
            from: 'script',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    },
    createCharacterOpen: {
        logger: createCharacterOpenLogger,
        commonParams: {
            from: 'script',
            ev_l_t: 'show',
            pos_id: '1662__',
            source: 'pc'
        }
    }
};

function log(type, params = {}, action = 'click') {
    try {
        const {value, extParam = {}} = params;
        const {logger, commonParams} = logMap[type];

        logger.send({
            ...commonParams,
            type: action,
            value,
            ext: extParam
        });

        // console.log('log =====>', type, {
        //     value,
        //     ext: extParam
        // });
    }
    catch (e) {
        // safe log
    }
}

export const tutorialScoreLog = (ext) => {
    log('tutorialScore', {
        extParam: {
            date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            ...ext
        }
    });
};

export const createCharacterTimeLog = (ext) => {
    log('createCharacterTime', {
        extParam: {
            date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            ...ext
        }
    });
};

export const createCharacterOpenLog = (ext) => {
    log('createCharacterOpen', {
        extParam: {
            date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            ...ext
        }
    });
};
